module.exports = __webpack_public_path__ + "img/screen-mobile-1.f3a1d976.png";